export const UB_REF_QUERY_PARAM_VALUE = 'plans_comparison_summary';

/**
 * Query param for monolith subscription checkout to detect org-growth plans & pricing entry (not `ref`).
 * Pass `subscriptionCheckoutEntry={SUBSCRIPTION_CHECKOUT_ENTRY_VALUE}` into `PersonalPlanCard` so the CTA href includes it.
 */
export const SUBSCRIPTION_CHECKOUT_ENTRY_PARAM = 'subscription_checkout_entry';
export const SUBSCRIPTION_CHECKOUT_ENTRY_VALUE = 'org_growth_plans_pricing';

/** Pass into `udLink.to('personal-plan', null, …)` where the third argument is query params. */
export const SUBSCRIPTION_CHECKOUT_ENTRY_UDLINK_PARAMS = {
    [SUBSCRIPTION_CHECKOUT_ENTRY_PARAM]: SUBSCRIPTION_CHECKOUT_ENTRY_VALUE,
} as const;

const appendSubscriptionCheckoutEntry = (queryString: string): string => {
    const params = new URLSearchParams(queryString.replace(/^\?/, ''));
    params.set(SUBSCRIPTION_CHECKOUT_ENTRY_PARAM, SUBSCRIPTION_CHECKOUT_ENTRY_VALUE);
    return params.toString();
};

export const STARTER_PLAN_CHECKOUT_URL = `https://www.udemy.com/subscription-checkout/express/?${appendSubscriptionCheckoutEntry(
    'product_type=CONSUMERSUBSCRIPTION_VALUE_PLAN&plan_preference=YEAR',
)}`;
export const PERSONAL_PLAN_CHECKOUT_URL = `https://www.udemy.com/subscription-checkout/express/?${appendSubscriptionCheckoutEntry(
    'product_type=CONSUMERSUBSCRIPTION&plan_preference=YEAR',
)}`;
export const PERSONAL_PLAN_UPGRADE_URL = `https://www.udemy.com/subscription-checkout/upgrade/?${appendSubscriptionCheckoutEntry(
    'upgrade_type=tier&product_type=CONSUMERSUBSCRIPTION',
)}`;

// HACK HACK HACK - this should only ever be used to format prices for the team plan v1 fallback
export const TEAM_PLAN_V1_FALLBACK_CURRENCY_FORMATTER = {
    currency: 'usd',
    symbol: '$',
    locale: 'en_US',
    decimal: '.',
    group: ',',
    pattern: '!#,##0.00',
    scale: 2,
};

// Hero billboard image intrinsic dimensions (used for width/height attributes to prevent CLS)
export const HERO_DESKTOP_WIDTH = 1440;
export const HERO_DESKTOP_HEIGHT = 695;
export const HERO_MOBILE_WIDTH = 700;
export const HERO_MOBILE_HEIGHT = 640;
